import { render, staticRenderFns } from "./QualityMeasureResults.vue?vue&type=template&id=563ac4de&"
import script from "./QualityMeasureResults.vue?vue&type=script&lang=js&"
export * from "./QualityMeasureResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports